import React from 'react';

export const Team = (props) => (
  <svg
    fill="none"
    height="19"
    viewBox="0 0 20 19"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.07745 4.50301C8.07745 5.56509 7.21646 6.42608 6.15437 6.42608C5.09229 6.42608 4.2313 5.56509 4.2313 4.50301C4.2313 3.44092 5.09229 2.57993 6.15437 2.57993C7.21646 2.57993 8.07745 3.44092 8.07745 4.50301Z"
      stroke="#2F1359"
      strokeWidth="0.769231"
    />
    <path
      d="M2.69248 10.142C2.69248 9.81922 2.92324 9.27805 3.50143 8.80337C4.06508 8.34063 4.93884 7.96274 6.15402 7.96274C7.36919 7.96274 8.24295 8.34063 8.8066 8.80337C9.38479 9.27805 9.61555 9.81922 9.61555 10.142V10.655C9.61555 10.7571 9.57503 10.8549 9.5029 10.927C9.43077 10.9991 9.33294 11.0397 9.23094 11.0397H3.07709C2.97509 11.0397 2.87726 10.9991 2.80513 10.927C2.733 10.8549 2.69248 10.7571 2.69248 10.655V10.142Z"
      stroke="#2F1359"
      strokeWidth="0.769231"
    />
    <path
      d="M15.7698 4.50301C15.7698 5.56509 14.9088 6.42608 13.8468 6.42608C12.7847 6.42608 11.9237 5.56509 11.9237 4.50301C11.9237 3.44092 12.7847 2.57993 13.8468 2.57993C14.9088 2.57993 15.7698 3.44092 15.7698 4.50301Z"
      stroke="#2F1359"
      strokeWidth="0.769231"
    />
    <path
      d="M10.3849 10.142C10.3849 9.81922 10.6156 9.27805 11.1938 8.80337C11.7575 8.34063 12.6312 7.96274 13.8464 7.96274C15.0616 7.96274 15.9353 8.34063 16.499 8.80337C17.0772 9.27805 17.3079 9.81922 17.3079 10.142V10.655C17.3079 10.7571 17.2674 10.8549 17.1953 10.927C17.1232 10.9991 17.0253 11.0397 16.9233 11.0397H10.7695C10.6675 11.0397 10.5696 10.9991 10.4975 10.927C10.4254 10.8549 10.3849 10.7571 10.3849 10.655V10.142Z"
      stroke="#2F1359"
      strokeWidth="0.769231"
    />
    <path
      className="team-icon-path-white"
      d="M12.6922 9.88533C12.6922 11.3721 11.4869 12.5774 10.0001 12.5774C8.51326 12.5774 7.30796 11.3721 7.30796 9.88533C7.30796 8.39851 8.51326 7.19321 10.0001 7.19321C11.4869 7.19321 12.6922 8.39851 12.6922 9.88533Z"
      fill="white"
      stroke="white"
      strokeWidth="0.769231"
    />
    <path
      className="team-icon-path"
      d="M11.9236 9.88582C11.9236 10.9479 11.0627 11.8089 10.0006 11.8089C8.93848 11.8089 8.07749 10.9479 8.07749 9.88582C8.07749 8.82373 8.93848 7.96274 10.0006 7.96274C11.0627 7.96274 11.9236 8.82373 11.9236 9.88582Z"
      fill="white"
      stroke="#2F1359"
      strokeWidth="0.769231"
    />
    <path
      className="team-icon-path"
      d="M6.53867 15.5248C6.53867 15.202 6.76944 14.6609 7.34762 14.1862C7.91127 13.7234 8.78503 13.3456 10.0002 13.3456C11.2154 13.3456 12.0891 13.7234 12.6528 14.1862C13.231 14.6609 13.4617 15.202 13.4617 15.5248V16.0379C13.4617 16.1399 13.4212 16.2377 13.3491 16.3098C13.277 16.382 13.1791 16.4225 13.0771 16.4225H6.92328C6.82128 16.4225 6.72345 16.382 6.65132 16.3098C6.57919 16.2377 6.53867 16.1399 6.53867 16.0379V15.5248Z"
      stroke="#2F1359"
      strokeWidth="0.769231"
    />
  </svg>
);
